export default __webpack_public_path__ + "static/media/IMG-20241005-WA0007.c25cbd00.jpg";